export const EN_US = "en-US";
